/*
* @Author: tengmaoqing
* @Date:   2018-04-25 15:12:30
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-12 17:54:07
*/

import { getEvInfo, getPayway } from '@/apis/base.js';

export default {
  namespaced: true,
  state: () => {
    return {
      info: {}
    };
  },
  actions: {
    async getEvInfo ({ commit }, evID) {
      try {
        const res = await getEvInfo(evID);
        if (res.success) {
          let { activityList } = res._data || {};
          if (activityList && activityList.length > 1) {
            res._data.activityList = activityList.filter((v, i) => i === 0);
          }
          commit('setEvInfo', res._data);
        }
      } catch (e) {
        console.log('order', e);
      }
    },
    async getPayway ({ commit }) {
      try {
        const res = await getPayway();
        if (res.success) {
          commit('setPayway', res._data);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  mutations: {
    setEvInfo (state, data) {
      state.info = data;
    },
    setPayway (state, data) {
      state.payway = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/ev-info/store.js